import { AsyncPipe, CommonModule, DatePipe, NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { PanelModule } from 'primeng/panel';
import { lastValueFrom, BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EncounterClosureReason, EncounterStatus, TealCompEncounterHeader } from '../../../models/encounter';
import { Store } from '@ngxs/store';
import { EncounterState } from '../../../state/encounters/encounter-state';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { DropdownModule } from 'primeng/dropdown';
import { User, UserHeader, UserService } from '@harlowe/core'
import { UserState } from '@harlowe/core';
import { EncounterFilter, EncounterService } from '../../../services/encounter.service';
import { Encounters } from '../../../state/encounters/encounter-actions';
import { UserInterfaceState } from '../../../state/ui/ui-state';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormsModule } from '@angular/forms';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { instanceToInstance } from 'class-transformer';
import { TabViewModule } from 'primeng/tabview';

@Component({
  selector: 'app-encounter-manager',
  standalone: true,
  imports: [TabViewModule, CommonModule, PanelModule, NgIf, NgFor, DatePipe, AsyncPipe,TableModule,
            CardModule,ButtonModule,TooltipModule, AsyncPipe,
            OverlayPanelModule, DropdownModule, MultiSelectModule, 
            FormsModule, ButtonGroupModule],
  templateUrl: './encounter-manager.component.html',
  styleUrl: './encounter-manager.component.scss'
})
export class EncounterManagerComponent 
{

  constructor
  (
    private _store:Store, 
    private _user:UserService,
    private _encounter:EncounterService
  )
  {
    this._store.select(EncounterState.activeEncounterFilter)
    .subscribe
    (
      f => 
        {
          this.filter = f;
          this.cleanFilter = instanceToInstance(f);
        }
    )
  }

  private _searchResultsSource$ : Observable<Map<string, TealCompEncounterHeader[]>> = this._store.select(EncounterState.encounterSearchResults);

  private _sortOrder$ = new BehaviorSubject<number>(-1);

  searchResults$ : Observable<Map<string, TealCompEncounterHeader[]>> = combineLatest([
    this._searchResultsSource$,
    this._sortOrder$
  ]).pipe(
    map(([results, sortOrder]) => {
      if(!results) return results;
      const sorted = new Map<string, TealCompEncounterHeader[]>();
      results.forEach((list, key) => {
        const copy = [...list].sort((a, b) => {
          const da = new Date((a as any).createDate).getTime();
          const db = new Date((b as any).createDate).getTime();
          return (da - db) * sortOrder;
        });
        sorted.set(key, copy);
      });
      return sorted;
    })
  );
  activeUsers$: Promise<UserHeader[]> = this._user.getActiveUsers();
  currentUser$ : Observable<User | undefined> = this._store.select(UserState.currentUser);
  closureReasons$ : Observable<EncounterClosureReason[] | undefined> = this._store.select(UserInterfaceState.encounterClosureReasons);
  statuses$ : Observable<EncounterStatus[] | undefined> = this._store.select(UserInterfaceState.encounterStatuses);
  sortOrder: number = -1;
  sortField: string = 'createDate';

  filter?: EncounterFilter;
  cleanFilter? :EncounterFilter;
  filterDirty: boolean = false; 

  encounterSelected(event: TealCompEncounterHeader)
  {

  }

  sortByDate()
  {
    this.sortOrder = this.sortOrder === 1 ? -1 : 1;
    this._sortOrder$.next(this.sortOrder);
  }

  assignEncounter(encounterId:number, u:User | undefined)
  {
    if(u)
    {
      this._encounter.assignEncounter(encounterId,u.id);
    }  
  }

  openEncounter(encounter: TealCompEncounterHeader)
  {
    this._store.dispatch(new Encounters.EncounterOpenedFromEncounterManager({header:encounter}));
  }

  closeEncounter(encounter: TealCompEncounterHeader, reason: EncounterClosureReason | undefined)
  {
    console.log(reason);
    if(reason)
      this._encounter.closeEncounter(encounter.id,reason.id);
  }

  reFilter()
  {
    if(this.filter)
    {
      lastValueFrom(this._store.dispatch(new Encounters.EncounterFilterSet({filter:this.filter})))
      .then
      (
        v=> this.resetFilter()
      );
    }
  }

  resetFilter()
  {
    this.filter = instanceToInstance(this.cleanFilter);
    this.filterDirty = false;
  }
}
